import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import store from './store/reducers';
import theme from './config/theme';
import translations from './config/translations';
import Onboarding from './pages/Invite/Onboarding';
import Registration from './pages/Registration/Registration';
import Error from './pages/Error/Error404';
import GoogleAnalyticsService from './services/GoogleAnalyticsService';
import Path from './utils/Path';

function App() {
  GoogleAnalyticsService.pageView();
  return (
    <>
      <I18nextProvider i18n={translations.invite}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <Route exact path={Path.root()} component={Error} />
              <Route exact path={Path.invite()} component={Onboarding} />
              <Route exact path={Path.permInvite()} component={Onboarding} />
            </BrowserRouter>
          </ThemeProvider>
        </Provider>
      </I18nextProvider>
      <I18nextProvider i18n={translations.registration}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <Route exact path={Path.registration()} component={Registration} />
            </BrowserRouter>
          </ThemeProvider>
        </Provider>
      </I18nextProvider>
    </>
  );
}

export default App;
